var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowVod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "81.000000pt",
    height: "197.000000pt",
    viewBox: "0 0 111.000000 197.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0,197.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372 1814 c-33 -23 -42 -53 -27 -89 6 -17 103 -185 215 -374 112 -190 203 -349 203 -355 0 -6 -96 -173 -213 -371 -132 -223 -213 -370 -213 -387 -1 -50 46 -83 95 -66 22 8 71 85 259 401 163 275 232 401 232 422 0 21 -66 141 -227 415 -125 212 -233 390 -239 397 -21 21 -61 25 -85 7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowVod);
export default __webpack_public_path__ + "static/media/rightArrowVod.33601a61ca79bfe76d9331ad431e817c.svg";
export { ForwardRef as ReactComponent };